<template lang="pug">
ValidationProvider(
  v-slot="{ errors }"
  :rules="rules"
  name="task_id"
)
  .form-group(:class="{ 'has-error': errors[0] }")
    .row.margin-bottom-sm
      .col-sm-12
        label.control-label.grouped_select {{ taskLabel }}
        AppSelect.task-app-select(
          ref="select"
          v-model="taskId"
          :disabled="noProject || disabled"
          :select2-options="getSelect2Options"
          :disabled-tooltip="disabledTooltip"
          async
        )
    span.help-block {{ errors[0] }}
</template>

<script>
import { mapGetters } from 'vuex';
import { getTaskFlavourLabel, getProjectFlavourLabel } from '~/utils/project_flavour';

export default {
  name: 'TimeEntriesTaskSelect',
  props: {
    value: {
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    projectId: {
      required: true,
      default: null,
    },
    userId: {
      required: true,
      default: null,
    },
    initialOptions: {
      required: false,
      default: () => [],
    },
    manualTimeRequest: {
      type: Boolean,
      default: false,
    },
    extendTimeUsingManualTimeRequest: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['projectFlavour']),
    taskId: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit('input', newValue);
      },
    },
    tasks() {
      return this.initialOptions;
    },
    taskLabel() {
      return this.label + (this.required ? '*' : '');
    },
    label() {
      return getTaskFlavourLabel(this.projectFlavour, false, this.manualTimeRequest && !this.extendTimeUsingManualTimeRequest);
    },
    placeholder() {
      return `Select a ${this.label.toLowerCase()}`;
    },
    noProject() {
      return !this.projectId;
    },
    rules() {
      return this.required ? 'required' : '';
    },
    disabledTooltip() {
      if (this.noProject && !this.disabled) {
        return '';
      }

      const label = getProjectFlavourLabel(this.projectFlavour, false, this.manualTimeRequest && !this.extendTimeUsingManualTimeRequest);

      return `Please select a ${label.toLowerCase()} first`;
    },
    getSelect2Options() {
      const vm = this;

      return {
        allowClear: true,
        placeholder: this.placeholder,
        multiple: false,
        data: this.tasks,
        width: '100%',
        language: {
          noResults: function () {
            if (vm.projectFlavour === 'both') {
              return 'No to-dos / No jobs';
            }
            if (vm.projectFlavour === 'work_orders') {
              return 'No jobs';
            }

            return 'No to-dos';
          },
        },
        ajax: {
          url: '/tasks/search',
          data: (params) => {
            return {
              project_id: vm.projectId,
              user_id: [vm.userId],
              q: params.term,
              page: params.page,
            };
          },
          processResults(data) {
            const tasks = data.results.map((task) => ({
              id: task.id,
              label: task.text,
              text: task.text,
              name: task.text,
            }));

            return { results: tasks, pagination: data.pagination };
          },
          transport(params, success, failure) {
            if ([vm.projectId].length > 0 && [vm.userId].length > 0) {
              const $request = $.ajax(params);

              $request.then(success);
              $request.fail(failure);

              return $request;
            }
            success({ results: [] });

            return false;
          },
          dataType: 'json',
          delay: 250,
        },
      };
    },
  },
};
</script>
